import { render, staticRenderFns } from "./GlobalLoading.vue?vue&type=template&id=7aca01cc&scoped=true&"
import script from "./GlobalLoading.vue?vue&type=script&lang=js&"
export * from "./GlobalLoading.vue?vue&type=script&lang=js&"
import style0 from "./GlobalLoading.vue?vue&type=style&index=0&id=7aca01cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aca01cc",
  null
  
)

export default component.exports